/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type AcceptInviteRequest,
    AcceptInviteRequestFromJSON,
    AcceptInviteRequestToJSON,
} from '../models/AcceptInviteRequest';
import {
    type AdminInviteUserRequest,
    AdminInviteUserRequestFromJSON,
    AdminInviteUserRequestToJSON,
} from '../models/AdminInviteUserRequest';
import {
    type AdminInviteUserResponse,
    AdminInviteUserResponseFromJSON,
    AdminInviteUserResponseToJSON,
} from '../models/AdminInviteUserResponse';
import {
    type AdminRedriveStuckFlowRunsRequest,
    AdminRedriveStuckFlowRunsRequestFromJSON,
    AdminRedriveStuckFlowRunsRequestToJSON,
} from '../models/AdminRedriveStuckFlowRunsRequest';
import {
    type AdminRedriveStuckFlowRunsResponse,
    AdminRedriveStuckFlowRunsResponseFromJSON,
    AdminRedriveStuckFlowRunsResponseToJSON,
} from '../models/AdminRedriveStuckFlowRunsResponse';
import {
    type AdminSendSmsRequest,
    AdminSendSmsRequestFromJSON,
    AdminSendSmsRequestToJSON,
} from '../models/AdminSendSmsRequest';
import {
    type AttachPhoneConfirmRequest,
    AttachPhoneConfirmRequestFromJSON,
    AttachPhoneConfirmRequestToJSON,
} from '../models/AttachPhoneConfirmRequest';
import {
    type AttachPhoneStartRequest,
    AttachPhoneStartRequestFromJSON,
    AttachPhoneStartRequestToJSON,
} from '../models/AttachPhoneStartRequest';
import {
    type CheckHealthResponse,
    CheckHealthResponseFromJSON,
    CheckHealthResponseToJSON,
} from '../models/CheckHealthResponse';
import {
    type GetCurrentUserResponse,
    GetCurrentUserResponseFromJSON,
    GetCurrentUserResponseToJSON,
} from '../models/GetCurrentUserResponse';
import {
    type GetGoogleLoginUrlResponse,
    GetGoogleLoginUrlResponseFromJSON,
    GetGoogleLoginUrlResponseToJSON,
} from '../models/GetGoogleLoginUrlResponse';
import {
    type HTTPValidationError,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
} from '../models/HTTPValidationError';
import {
    type MeAttachPhoneConfirmRequest,
    MeAttachPhoneConfirmRequestFromJSON,
    MeAttachPhoneConfirmRequestToJSON,
} from '../models/MeAttachPhoneConfirmRequest';
import {
    type MeAttachPhoneStartRequest,
    MeAttachPhoneStartRequestFromJSON,
    MeAttachPhoneStartRequestToJSON,
} from '../models/MeAttachPhoneStartRequest';
import {
    type PasswordLoginResponse,
    PasswordLoginResponseFromJSON,
    PasswordLoginResponseToJSON,
} from '../models/PasswordLoginResponse';
import {
    type PasswordResetConfirmRequest,
    PasswordResetConfirmRequestFromJSON,
    PasswordResetConfirmRequestToJSON,
} from '../models/PasswordResetConfirmRequest';
import {
    type PasswordResetRequest,
    PasswordResetRequestFromJSON,
    PasswordResetRequestToJSON,
} from '../models/PasswordResetRequest';
import {
    type PhoneLoginResponse,
    PhoneLoginResponseFromJSON,
    PhoneLoginResponseToJSON,
} from '../models/PhoneLoginResponse';
import {
    type PhoneLoginStartRequest,
    PhoneLoginStartRequestFromJSON,
    PhoneLoginStartRequestToJSON,
} from '../models/PhoneLoginStartRequest';
import {
    type PhoneLoginVerifyRequest,
    PhoneLoginVerifyRequestFromJSON,
    PhoneLoginVerifyRequestToJSON,
} from '../models/PhoneLoginVerifyRequest';

export interface AcceptInviteOperationRequest {
    /**
     * 
     */
    acceptInviteRequest: AcceptInviteRequest;
}

export interface AttachPhoneConfirmOperationRequest {
    /**
     * 
     */
    attachPhoneConfirmRequest: AttachPhoneConfirmRequest;
}

export interface AttachPhoneStartOperationRequest {
    /**
     * 
     */
    attachPhoneStartRequest: AttachPhoneStartRequest;
}

export interface GetCurrentUserRequest {
    /**
     * 
     */
    accessToken?: string | null;
}

export interface GetGoogleLoginUrlRequest {
    /**
     * 
     */
    redirectUrl?: string | null;
    /**
     * 
     */
    inviteToken?: string | null;
}

export interface GoogleLoginCallbackRequest {
    /**
     * 
     */
    error?: string | null;
    /**
     * 
     */
    code?: string | null;
    /**
     * 
     */
    googleInviteToken?: string | null;
}

export interface InviteUserRequest {
    /**
     * 
     */
    adminInviteUserRequest: AdminInviteUserRequest;
    /**
     * 
     */
    accessToken?: string | null;
}

export interface LoginWithPasswordRequest {
    /**
     * 
     */
    username: string;
    /**
     * 
     */
    password: string;
    /**
     * 
     */
    grantType?: string | null;
    /**
     * 
     */
    scope?: string;
    /**
     * 
     */
    clientId?: string | null;
    /**
     * 
     */
    clientSecret?: string | null;
}

export interface MeAttachPhoneConfirmOperationRequest {
    /**
     * 
     */
    meAttachPhoneConfirmRequest: MeAttachPhoneConfirmRequest;
    /**
     * 
     */
    accessToken?: string | null;
}

export interface MeAttachPhoneStartOperationRequest {
    /**
     * 
     */
    meAttachPhoneStartRequest: MeAttachPhoneStartRequest;
    /**
     * 
     */
    accessToken?: string | null;
}

export interface PasswordResetConfirmOperationRequest {
    /**
     * 
     */
    passwordResetConfirmRequest: PasswordResetConfirmRequest;
}

export interface PasswordResetRequestRequest {
    /**
     * 
     */
    passwordResetRequest: PasswordResetRequest;
}

export interface PhoneLoginStartOperationRequest {
    /**
     * 
     */
    phoneLoginStartRequest: PhoneLoginStartRequest;
}

export interface PhoneLoginVerifyOperationRequest {
    /**
     * 
     */
    phoneLoginVerifyRequest: PhoneLoginVerifyRequest;
}

export interface RedirectRequest {
    /**
     * 
     */
    redirectUrl?: string | null;
}

export interface RedriveStuckFlowRunsRequest {
    /**
     * 
     */
    adminRedriveStuckFlowRunsRequest: AdminRedriveStuckFlowRunsRequest;
    /**
     * 
     */
    accessToken?: string | null;
}

export interface SendSmsRequest {
    /**
     * 
     */
    adminSendSmsRequest: AdminSendSmsRequest;
    /**
     * 
     */
    accessToken?: string | null;
}

/**
 * 
 */
export class DefaultApi extends runtime.BaseAPI {

    /**
     * Creates request options for acceptInvite without sending the request
     */
    async acceptInviteRequestOpts(requestParameters: AcceptInviteOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['acceptInviteRequest'] == null) {
            throw new runtime.RequiredError(
                'acceptInviteRequest',
                'Required parameter "acceptInviteRequest" was null or undefined when calling acceptInvite().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/users/accept-invite`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AcceptInviteRequestToJSON(requestParameters['acceptInviteRequest']),
        };
    }

    /**
     * Accept Invite
     */
    async acceptInviteRaw(requestParameters: AcceptInviteOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.acceptInviteRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Accept Invite
     */
    async acceptInvite(requestParameters: AcceptInviteOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.acceptInviteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for attachPhoneConfirm without sending the request
     */
    async attachPhoneConfirmRequestOpts(requestParameters: AttachPhoneConfirmOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['attachPhoneConfirmRequest'] == null) {
            throw new runtime.RequiredError(
                'attachPhoneConfirmRequest',
                'Required parameter "attachPhoneConfirmRequest" was null or undefined when calling attachPhoneConfirm().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/users/attach-phone-confirm`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AttachPhoneConfirmRequestToJSON(requestParameters['attachPhoneConfirmRequest']),
        };
    }

    /**
     * Attach Phone Confirm
     */
    async attachPhoneConfirmRaw(requestParameters: AttachPhoneConfirmOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.attachPhoneConfirmRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Attach Phone Confirm
     */
    async attachPhoneConfirm(requestParameters: AttachPhoneConfirmOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.attachPhoneConfirmRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for attachPhoneStart without sending the request
     */
    async attachPhoneStartRequestOpts(requestParameters: AttachPhoneStartOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['attachPhoneStartRequest'] == null) {
            throw new runtime.RequiredError(
                'attachPhoneStartRequest',
                'Required parameter "attachPhoneStartRequest" was null or undefined when calling attachPhoneStart().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/users/attach-phone-start`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AttachPhoneStartRequestToJSON(requestParameters['attachPhoneStartRequest']),
        };
    }

    /**
     * Attach Phone Start
     */
    async attachPhoneStartRaw(requestParameters: AttachPhoneStartOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.attachPhoneStartRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Attach Phone Start
     */
    async attachPhoneStart(requestParameters: AttachPhoneStartOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.attachPhoneStartRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for checkHealth without sending the request
     */
    async checkHealthRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/health`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Check Health
     */
    async checkHealthRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CheckHealthResponse>> {
        const requestOptions = await this.checkHealthRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CheckHealthResponseFromJSON(jsonValue));
    }

    /**
     * Check Health
     */
    async checkHealth(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CheckHealthResponse> {
        const response = await this.checkHealthRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for generateHandledException without sending the request
     */
    async generateHandledExceptionRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/test/handled-exception`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Generate Handled Exception
     */
    async generateHandledExceptionRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.generateHandledExceptionRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Generate Handled Exception
     */
    async generateHandledException(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.generateHandledExceptionRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for generateUnhandledException without sending the request
     */
    async generateUnhandledExceptionRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/test/unhandled-exception`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Generate Unhandled Exception
     */
    async generateUnhandledExceptionRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.generateUnhandledExceptionRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Generate Unhandled Exception
     */
    async generateUnhandledException(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.generateUnhandledExceptionRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getCurrentUser without sending the request
     */
    async getCurrentUserRequestOpts(requestParameters: GetCurrentUserRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/users/me`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get Current User
     */
    async getCurrentUserRaw(requestParameters: GetCurrentUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCurrentUserResponse>> {
        const requestOptions = await this.getCurrentUserRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCurrentUserResponseFromJSON(jsonValue));
    }

    /**
     * Get Current User
     */
    async getCurrentUser(requestParameters: GetCurrentUserRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCurrentUserResponse> {
        const response = await this.getCurrentUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getGoogleLoginUrl without sending the request
     */
    async getGoogleLoginUrlRequestOpts(requestParameters: GetGoogleLoginUrlRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['redirectUrl'] != null) {
            queryParameters['redirect_url'] = requestParameters['redirectUrl'];
        }

        if (requestParameters['inviteToken'] != null) {
            queryParameters['invite_token'] = requestParameters['inviteToken'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/auth/login/google/url`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get Google Login Url
     */
    async getGoogleLoginUrlRaw(requestParameters: GetGoogleLoginUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetGoogleLoginUrlResponse>> {
        const requestOptions = await this.getGoogleLoginUrlRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetGoogleLoginUrlResponseFromJSON(jsonValue));
    }

    /**
     * Get Google Login Url
     */
    async getGoogleLoginUrl(requestParameters: GetGoogleLoginUrlRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetGoogleLoginUrlResponse> {
        const response = await this.getGoogleLoginUrlRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for googleLoginCallback without sending the request
     */
    async googleLoginCallbackRequestOpts(requestParameters: GoogleLoginCallbackRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['error'] != null) {
            queryParameters['error'] = requestParameters['error'];
        }

        if (requestParameters['code'] != null) {
            queryParameters['code'] = requestParameters['code'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/auth/login/google/callback`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Google Login Callback
     */
    async googleLoginCallbackRaw(requestParameters: GoogleLoginCallbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.googleLoginCallbackRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Google Login Callback
     */
    async googleLoginCallback(requestParameters: GoogleLoginCallbackRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.googleLoginCallbackRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for inviteUser without sending the request
     */
    async inviteUserRequestOpts(requestParameters: InviteUserRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['adminInviteUserRequest'] == null) {
            throw new runtime.RequiredError(
                'adminInviteUserRequest',
                'Required parameter "adminInviteUserRequest" was null or undefined when calling inviteUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/admin/invite-user`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdminInviteUserRequestToJSON(requestParameters['adminInviteUserRequest']),
        };
    }

    /**
     * Invite User
     */
    async inviteUserRaw(requestParameters: InviteUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminInviteUserResponse>> {
        const requestOptions = await this.inviteUserRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminInviteUserResponseFromJSON(jsonValue));
    }

    /**
     * Invite User
     */
    async inviteUser(requestParameters: InviteUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminInviteUserResponse> {
        const response = await this.inviteUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for loginWithPassword without sending the request
     */
    async loginWithPasswordRequestOpts(requestParameters: LoginWithPasswordRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['username'] == null) {
            throw new runtime.RequiredError(
                'username',
                'Required parameter "username" was null or undefined when calling loginWithPassword().'
            );
        }

        if (requestParameters['password'] == null) {
            throw new runtime.RequiredError(
                'password',
                'Required parameter "password" was null or undefined when calling loginWithPassword().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'application/x-www-form-urlencoded' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['grantType'] != null) {
            formParams.append('grant_type', requestParameters['grantType'] as any);
        }

        if (requestParameters['username'] != null) {
            formParams.append('username', requestParameters['username'] as any);
        }

        if (requestParameters['password'] != null) {
            formParams.append('password', requestParameters['password'] as any);
        }

        if (requestParameters['scope'] != null) {
            formParams.append('scope', requestParameters['scope'] as any);
        }

        if (requestParameters['clientId'] != null) {
            formParams.append('client_id', requestParameters['clientId'] as any);
        }

        if (requestParameters['clientSecret'] != null) {
            formParams.append('client_secret', requestParameters['clientSecret'] as any);
        }


        let urlPath = `/auth/login/password`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        };
    }

    /**
     * Login With Password
     */
    async loginWithPasswordRaw(requestParameters: LoginWithPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PasswordLoginResponse>> {
        const requestOptions = await this.loginWithPasswordRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PasswordLoginResponseFromJSON(jsonValue));
    }

    /**
     * Login With Password
     */
    async loginWithPassword(requestParameters: LoginWithPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PasswordLoginResponse> {
        const response = await this.loginWithPasswordRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for logout without sending the request
     */
    async logoutRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/auth/logout`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Logout
     */
    async logoutRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const requestOptions = await this.logoutRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Logout
     */
    async logout(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.logoutRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for meAttachPhoneConfirm without sending the request
     */
    async meAttachPhoneConfirmRequestOpts(requestParameters: MeAttachPhoneConfirmOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['meAttachPhoneConfirmRequest'] == null) {
            throw new runtime.RequiredError(
                'meAttachPhoneConfirmRequest',
                'Required parameter "meAttachPhoneConfirmRequest" was null or undefined when calling meAttachPhoneConfirm().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/users/me/attach-phone-confirm`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MeAttachPhoneConfirmRequestToJSON(requestParameters['meAttachPhoneConfirmRequest']),
        };
    }

    /**
     * Me Attach Phone Confirm
     */
    async meAttachPhoneConfirmRaw(requestParameters: MeAttachPhoneConfirmOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.meAttachPhoneConfirmRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Me Attach Phone Confirm
     */
    async meAttachPhoneConfirm(requestParameters: MeAttachPhoneConfirmOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.meAttachPhoneConfirmRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for meAttachPhoneStart without sending the request
     */
    async meAttachPhoneStartRequestOpts(requestParameters: MeAttachPhoneStartOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['meAttachPhoneStartRequest'] == null) {
            throw new runtime.RequiredError(
                'meAttachPhoneStartRequest',
                'Required parameter "meAttachPhoneStartRequest" was null or undefined when calling meAttachPhoneStart().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/users/me/attach-phone-start`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MeAttachPhoneStartRequestToJSON(requestParameters['meAttachPhoneStartRequest']),
        };
    }

    /**
     * Session-authenticated phone attach/replace. Unlike the invite-time attach-phone endpoints above, this allows an existing phone to be replaced — the new number is OTP-verified before anything changes.
     * Me Attach Phone Start
     */
    async meAttachPhoneStartRaw(requestParameters: MeAttachPhoneStartOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.meAttachPhoneStartRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Session-authenticated phone attach/replace. Unlike the invite-time attach-phone endpoints above, this allows an existing phone to be replaced — the new number is OTP-verified before anything changes.
     * Me Attach Phone Start
     */
    async meAttachPhoneStart(requestParameters: MeAttachPhoneStartOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.meAttachPhoneStartRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for passwordResetConfirm without sending the request
     */
    async passwordResetConfirmRequestOpts(requestParameters: PasswordResetConfirmOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['passwordResetConfirmRequest'] == null) {
            throw new runtime.RequiredError(
                'passwordResetConfirmRequest',
                'Required parameter "passwordResetConfirmRequest" was null or undefined when calling passwordResetConfirm().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/auth/password-reset-confirm`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PasswordResetConfirmRequestToJSON(requestParameters['passwordResetConfirmRequest']),
        };
    }

    /**
     * Password Reset Confirm
     */
    async passwordResetConfirmRaw(requestParameters: PasswordResetConfirmOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.passwordResetConfirmRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Password Reset Confirm
     */
    async passwordResetConfirm(requestParameters: PasswordResetConfirmOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.passwordResetConfirmRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for passwordResetRequest without sending the request
     */
    async passwordResetRequestRequestOpts(requestParameters: PasswordResetRequestRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['passwordResetRequest'] == null) {
            throw new runtime.RequiredError(
                'passwordResetRequest',
                'Required parameter "passwordResetRequest" was null or undefined when calling passwordResetRequest().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/auth/password-reset-request`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PasswordResetRequestToJSON(requestParameters['passwordResetRequest']),
        };
    }

    /**
     * Password Reset Request
     */
    async passwordResetRequestRaw(requestParameters: PasswordResetRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.passwordResetRequestRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Password Reset Request
     */
    async passwordResetRequest(requestParameters: PasswordResetRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.passwordResetRequestRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for phoneLoginStart without sending the request
     */
    async phoneLoginStartRequestOpts(requestParameters: PhoneLoginStartOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['phoneLoginStartRequest'] == null) {
            throw new runtime.RequiredError(
                'phoneLoginStartRequest',
                'Required parameter "phoneLoginStartRequest" was null or undefined when calling phoneLoginStart().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/auth/login/phone/start`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PhoneLoginStartRequestToJSON(requestParameters['phoneLoginStartRequest']),
        };
    }

    /**
     * Phone Login Start
     */
    async phoneLoginStartRaw(requestParameters: PhoneLoginStartOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.phoneLoginStartRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Phone Login Start
     */
    async phoneLoginStart(requestParameters: PhoneLoginStartOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.phoneLoginStartRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for phoneLoginVerify without sending the request
     */
    async phoneLoginVerifyRequestOpts(requestParameters: PhoneLoginVerifyOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['phoneLoginVerifyRequest'] == null) {
            throw new runtime.RequiredError(
                'phoneLoginVerifyRequest',
                'Required parameter "phoneLoginVerifyRequest" was null or undefined when calling phoneLoginVerify().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/auth/login/phone/verify`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PhoneLoginVerifyRequestToJSON(requestParameters['phoneLoginVerifyRequest']),
        };
    }

    /**
     * Phone Login Verify
     */
    async phoneLoginVerifyRaw(requestParameters: PhoneLoginVerifyOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PhoneLoginResponse>> {
        const requestOptions = await this.phoneLoginVerifyRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PhoneLoginResponseFromJSON(jsonValue));
    }

    /**
     * Phone Login Verify
     */
    async phoneLoginVerify(requestParameters: PhoneLoginVerifyOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PhoneLoginResponse> {
        const response = await this.phoneLoginVerifyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for redirect without sending the request
     */
    async redirectRequestOpts(requestParameters: RedirectRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/auth/login/redirect`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Redirect
     */
    async redirectRaw(requestParameters: RedirectRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.redirectRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Redirect
     */
    async redirect(requestParameters: RedirectRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.redirectRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for redriveStuckFlowRuns without sending the request
     */
    async redriveStuckFlowRunsRequestOpts(requestParameters: RedriveStuckFlowRunsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['adminRedriveStuckFlowRunsRequest'] == null) {
            throw new runtime.RequiredError(
                'adminRedriveStuckFlowRunsRequest',
                'Required parameter "adminRedriveStuckFlowRunsRequest" was null or undefined when calling redriveStuckFlowRuns().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/admin/redrive-stuck-flow-runs`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdminRedriveStuckFlowRunsRequestToJSON(requestParameters['adminRedriveStuckFlowRunsRequest']),
        };
    }

    /**
     * Reset Prefect flow runs stuck in PENDING or RUNNING back to SCHEDULED.  Both states can be orphaned when the worker dies without notice:   - PENDING: worker died between SCHEDULED→PENDING and the actual     subprocess launch (e.g. OOM under a burst). Run never executed.   - RUNNING: worker died after launch. Without heartbeat-based zombie     detection configured (PREFECT_RUNNER_HEARTBEAT_FREQUENCY +     Automation), Prefect leaves these in RUNNING indefinitely.  Resetting to SCHEDULED makes the worker re-attempt on its next poll. Safe because sync_prefix is idempotent (source_device_key unique constraints dedup media; result.json/event ingest paths upsert).  Defaults to dry_run=True to make accidental invocation safe.
     * Redrive Stuck Flow Runs
     */
    async redriveStuckFlowRunsRaw(requestParameters: RedriveStuckFlowRunsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminRedriveStuckFlowRunsResponse>> {
        const requestOptions = await this.redriveStuckFlowRunsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminRedriveStuckFlowRunsResponseFromJSON(jsonValue));
    }

    /**
     * Reset Prefect flow runs stuck in PENDING or RUNNING back to SCHEDULED.  Both states can be orphaned when the worker dies without notice:   - PENDING: worker died between SCHEDULED→PENDING and the actual     subprocess launch (e.g. OOM under a burst). Run never executed.   - RUNNING: worker died after launch. Without heartbeat-based zombie     detection configured (PREFECT_RUNNER_HEARTBEAT_FREQUENCY +     Automation), Prefect leaves these in RUNNING indefinitely.  Resetting to SCHEDULED makes the worker re-attempt on its next poll. Safe because sync_prefix is idempotent (source_device_key unique constraints dedup media; result.json/event ingest paths upsert).  Defaults to dry_run=True to make accidental invocation safe.
     * Redrive Stuck Flow Runs
     */
    async redriveStuckFlowRuns(requestParameters: RedriveStuckFlowRunsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminRedriveStuckFlowRunsResponse> {
        const response = await this.redriveStuckFlowRunsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for sendSms without sending the request
     */
    async sendSmsRequestOpts(requestParameters: SendSmsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['adminSendSmsRequest'] == null) {
            throw new runtime.RequiredError(
                'adminSendSmsRequest',
                'Required parameter "adminSendSmsRequest" was null or undefined when calling sendSms().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/admin/send-sms`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdminSendSmsRequestToJSON(requestParameters['adminSendSmsRequest']),
        };
    }

    /**
     * Send Sms
     */
    async sendSmsRaw(requestParameters: SendSmsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.sendSmsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Send Sms
     */
    async sendSms(requestParameters: SendSmsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.sendSmsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
